import { removeDiacritics } from "./stringUtils";

export const RegimeOptions: Record<string | number, string> = {
    "1": "Laboral",
    "2": "Pós Laboral",
    "3": "Distância",
  };
    



/**
 * Separa o nome completo em nome(s) próprio(s) e apelido.
 * O apelido é a ÚLTIMA palavra, não a segunda: "Laerson Moises Mucauque"
 * dá nome "Laerson Moises" e apelido "Mucauque".
 */
export function splitFullName(fullName?: string | null): { firstName: string; lastName: string } {
  const parts = (fullName ?? "").trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) return { firstName: "", lastName: "" };
  if (parts.length === 1) return { firstName: parts[0], lastName: "" };

  return {
    firstName: parts.slice(0, -1).join(" "),
    lastName: parts[parts.length - 1],
  };
}

export function mapRegime(value: string | number): string {
  if (!value) return "1";

  if (RegimeOptions[value]) {
    return value.toString();
  }

  const normalizedInput = removeDiacritics(value.toString().toLowerCase().trim());

  const match = Object.entries(RegimeOptions).find(([key, label]) => {
    const normalizedLabel = removeDiacritics(label.toLowerCase());
    return normalizedInput === normalizedLabel;
  });

  return match ? match[0] : "1"; 
}
